import validate from "validate.js";
export default {
    isRegisteredCompany: {
        presence: true,
        type: "boolean",
    },
    companyNo: {
        length: { minimum: 2 },
        conditionalPresenceMatchAll: [
            {
                field: "isRegisteredCompany",
                value: true,
            },
        ],
        type: "string",
        format: {
            pattern: /^([\dA-Z]{2})\d{6}$/,
            message: (value) => validate.format("^%{num} is not a valid company number", {
                num: value,
            }),
        },
    },
    tradingAs: {
        type: "string",
        conditionalPresenceMatchAll: [
            {
                field: "isRegisteredCompany",
                value: false,
            },
        ],
    },
};
